import {imgHost} from '../env'

export default {
    data () {
        return {
            routeName: '',
            imgHost: imgHost
        }
    },
    methods: {
        goRouter: function (data) {
            this.$router.push(data)
        },
        openWindow: function (url) {
            window.open(url)
        }
    },
    created: function () {
        this.$nextTick(() => {
            let routeDom = this.$store.state.routeDom
            let route = this.$route.name
            if (routeDom[route]) {
                routeDom['index'].$el.style.color = "#999"
                routeDom['joinUs'].$el.style.color = "#999"
                routeDom['help'].$el.style.color = "#999"
                routeDom['privacy'].$el.style.color = "#999"
                routeDom[route].$el.style.color = "#FF6EA4"
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js